import React, { useEffect, useState } from 'react';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';

import searchImage from '../../assets/images/search-shipper.png';

import './HelpSearchOrderView.css';
import { TextField } from '../../components/TextField/TextField';
import { useGetOrdersQuery } from '../../apis/mlkApi/mlk.api.hooks';
import { OrderRow } from './components/OrderRow/OrderRow';
import { Order } from '../../models';

type HelpSearchOrderViewProps = {};

export const HelpSearchOrderView: React.FC<HelpSearchOrderViewProps> = () => {
  const [t] = useLanguage();
  const back = useBack();

  const [searchText, setSearchText] = useState('');
  const [ordersToShow, setOrdersToShow] = useState<Order[]>([]);

  const { data: orders } = useGetOrdersQuery(undefined);

  useEffect(() => {
    if (orders) {
      const filteredOrders = orders.orders.filter((o) =>
        (o.shipper.alias || o.shipper.name)
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
      setOrdersToShow(filteredOrders);
    }
  }, [orders, searchText]);

  return (
    <BaseLayout onBackClick={back} hasBack title={t('pageTitles.searchOrder')}>
      {orders && (
        <div className="search-order--body">
          <h2 className="search-order--title">{t('searchOrder.title')}</h2>
          <p className="paragraph">{t('searchOrder.description')}</p>
          <TextField
            isPlaceholderItalic
            value={searchText}
            onValueChange={setSearchText}
            node={
              <img
                alt="Search image"
                width={30}
                height={30}
                src={searchImage}
              />
            }
            placeholder={t('searchOrder.searchPlaceholder')}
          />
          {ordersToShow.map((o) => {
            return <OrderRow order={o} key={o.opaqueId} />;
          })}
        </div>
      )}
    </BaseLayout>
  );
};
